import React from 'react';
import styled from 'styled-components';

const CrmContainer = styled.div`
  display: flex;
  height: 100%;
  width: 100%;
  background-color: ${props => props.theme.colors.background};
  color: ${props => props.theme.colors.text};
  align-items: center;
  justify-content: center;
`;

const PlaceholderContent = styled.div`
  text-align: center;
  padding: 40px;
`;

const PlaceholderTitle = styled.h2`
  font-size: 24px;
  font-weight: 600;
  margin-bottom: 16px;
  color: ${props => props.theme.colors.text};
`;

const PlaceholderText = styled.p`
  font-size: 16px;
  color: ${props => props.theme.colors.textLight};
  margin-bottom: 24px;
`;

const PlaceholderIcon = styled.div`
  font-size: 64px;
  margin-bottom: 24px;
  opacity: 0.3;
`;

type CrmViewProps = {
  // Props futures pour la fonctionnalité CRM
};

const CrmView: React.FC<CrmViewProps> = () => {
  return (
    <CrmContainer>
      <PlaceholderContent>
        <PlaceholderIcon>🏢</PlaceholderIcon>
        <PlaceholderTitle>CRM</PlaceholderTitle>
        <PlaceholderText>
          Module CRM en cours de développement<br />
          Cette zone sera dédiée à la gestion des relations clients
        </PlaceholderText>
      </PlaceholderContent>
    </CrmContainer>
  );
};

export default CrmView;
